export default "__VITE_ASSET__eff41037__"